<template>
    <div class="usernotfound">
        <h1>User not found</h1>
        <p><router-link :to="{ name: 'Users' }">Back to Users</router-link></p>
    </div>
</template>